import config from '../../../utils/config';
import { serverStatusEnum } from './data';

// Ping server for response
export const getServerHeartbeatStatus = async () => {
    const ORIGIN = config.origin;

    try {
        const heartbeat = await fetch(`${ORIGIN}/wms/heartbeat/server`, {
            method: 'GET',
        });

        // Check for positive response status
        if (!heartbeat?.ok) {
            return serverStatusEnum.OFFLINE;
        }

        const data = await heartbeat.json();
        const version = data?.version;

        // If no version is returned, treat the server as offline
        if (!version) {
            return serverStatusEnum.OFFLINE;
        }

        // Compare server version with the version stored in local storage.
        // If they differ (or no version is stored yet), persist the new version
        // and reload the page so the user picks up the latest deployment.
        const storedVersion = localStorage.getItem('serverVersion');
        if (!storedVersion || storedVersion !== version) {
            localStorage.setItem('serverVersion', version);
            window.location.reload();
        }

        return serverStatusEnum.ONLINE;
    } catch (error) {
        return serverStatusEnum.OFFLINE;
    }
};
